module.exports = __webpack_public_path__ + "static/media/loc1_img21.4cc84600.jpg";